import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, Tab, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import Truck from "../transportation/truck.component";
import Driver from "../transportation/driver.component";

export default function ImpProcess() {
  const [t] = useTranslation();
  const [tab, setTab] = useState(0);
  const tabInfor = [
    // {id: 0, title: 'Kho hàng', component: <Inventory /> },
    { id: 1, title: "Xe vận tải", component: <Truck /> },
    { id: 2, title: "Lái xe vận tải", component: <Driver /> },
  ];

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridColumnGap: 20, backgroundColor: "#b3deff" }}>
        <Tabs value={tab} variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example" sx={{ backgroundColor: "#b3deff", height: "30px" }}>
          {tabInfor.map((item, index) => (
            <Tab sx={{ fontWeight: "regular" }} label={t(item.title)} wrapped onClick={() => setTab(index)} />
          ))}
        </Tabs>
        <section style={{ marginLeft: "auto" }}>
          <Button variant="outlined" sx={{ height: "50px", width: "50px" }}>
            <SearchIcon />
          </Button>
        </section>
      </div>
      {tabInfor.map((item, index) => (
        <div style={{ display: tab === item.id ? "" : "none" }}>{item.component}</div>
      ))}
    </div>
  );
}
